import { useState } from "react";

import type { Meta, StoryObj } from "@storybook/react";

import { fakeTimeSlotGroup } from "@/__mocks__/booking";
import type { BookingAvailabilityDayCardProps } from "@/ui/components/schedule/booking/BookingAvailabilityDayCard";
import BookingAvailabilityDayCard from "@/ui/components/schedule/booking/BookingAvailabilityDayCard";

const timeSlotGroup = fakeTimeSlotGroup();

const StoryMeta: Meta<BookingAvailabilityDayCardProps> = {
  title: "Components/Schedule/Booking/Booking Availability Day Card",
  component: BookingAvailabilityDayCard,
  argTypes: {
    day: { control: "text" },
    onSelect: { action: "onSelect" },
    selectedTimeSlotStartTime: { control: "text" },
    timeSlots: { control: "object" },
  },
  args: {
    day: timeSlotGroup.date,
    timeSlots: timeSlotGroup.timeSlots,
  },
  // eslint-disable-next-line no-restricted-syntax -- non-arrow function used here as React FC needed for use of state hook
  render: function Render(args) {
    const [selectedTimeSlotStartTime, setSelectedTimeSlotStartTime] = useState<
      string | undefined
    >(args.selectedTimeSlotStartTime);
    return (
      <BookingAvailabilityDayCard
        {...args}
        onSelect={(startTime) => {
          args.onSelect(startTime);
          setSelectedTimeSlotStartTime(startTime);
        }}
        selectedTimeSlotStartTime={selectedTimeSlotStartTime}
      />
    );
  },
};

type Story = StoryObj<BookingAvailabilityDayCardProps>;

export default StoryMeta;
export const Primary: Story = {};
